export default __webpack_public_path__ + "static/media/CustomNew1.3617fd6b.png";